export default __webpack_public_path__ + "e8d3e152c8429721f2a7b72f570bdfae.svg";